import { useEffect } from 'react';
import { browserName } from 'react-device-detect';
import { metricsPublisher } from '../metrics';
import { sessionContext } from '../utils/SessionContext';
import { DIMENSION_KEYS, METRIC_NAME } from '../types';

interface PropsType {
  children: JSX.Element;
}

/**
 * App initialization wrapper that sets up early metrics dimensions.
 */
export const AppInitWrapper: React.FC<PropsType> = ({ children }) => {
  useEffect(() => {
    metricsPublisher.addGlobalDimensions({
      [DIMENSION_KEYS.BROWSER]: browserName,
    });

    // Emit browser count with dimensions
    metricsPublisher.emitCount(METRIC_NAME.BROWSER_COUNT);

    const handlePageHide = () => sessionContext.emit('pagehide');
    window.addEventListener('pagehide', handlePageHide);
    return () => window.removeEventListener('pagehide', handlePageHide);
  }, []);

  return children;
};

export default AppInitWrapper;
